import * as Sentry from '@sentry/vue'

import { AuthApi } from '@/features/api/services/authApi.js'
import { AUTH_FLOW, reportAuthFlowError } from '@/features/auth/utils/reportAuthFlowError.js'
import { getActiveClubId } from '@/features/router/useActiveClub.js'

const errorCode = 'ERR_NETWORK'

let networkErrorRedirected = false

export function useGetMyDetails() {
  async function getCurrentUser() {
    try {
      const responseSalt = await AuthApi.myDetails()
      const response = responseSalt?.value

      console.log('[useAuthStore]', response)

      // Reset network error flag on successful request
      networkErrorRedirected = false

      Sentry.setUser({
        tenantIds: (response.myTenants || []).map(tenant => ({
          id: tenant.tenantId,
          name: tenant.name,
          hasOsiAccess: tenant.hasOsiAccess,
          tenantType: tenant.tenantType,
        })),
        email: response.email,
        name: response.name,
        surname: response.surname,
        appUserId: response.appUserId,
        profileId: response.profileId,
        registrationCompleted: response.registrationCompleted,
        type: response.type,
        typeString: response.typeString,
      })

      return response
    } catch (e) {
      console.error('[getCurrentUser] error:', {
        error: e,
        message: e?.message,
        response: e?.response,
        status: e?.response?.status,
        data: e?.response?.data,
        code: e?.code,
        stack: e?.stack,
      })

      if (e?.code === errorCode) {
        console.error('[getCurrentUser] Network error')

        // Prevent infinite redirect loop - only redirect once
        const currentPath = window.location.pathname
        const isOnErrorPage = currentPath?.includes('/error')

        if (!networkErrorRedirected && !isOnErrorPage) {
          networkErrorRedirected = true

          // Build error URL with activeClubId if it exists
          const redirectUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`
          const activeClubId = getActiveClubId()
          const errorUrl = new URL('/error', window.location.origin)
          errorUrl.searchParams.set('reason', 'network-error')
          errorUrl.searchParams.set('redirectUrl', redirectUrl)

          if (activeClubId) {
            errorUrl.searchParams.set('activeClubId', activeClubId)
          }

          window.location.href = errorUrl.toString()
        }

        return null
      }

      reportAuthFlowError({
        flow: AUTH_FLOW.SESSION,
        step: 'get-my-details',
        error: e,
      })

      throw e
    }
  }

  return getCurrentUser
}
